// removed by extract-text-webpack-plugin
module.exports = {"stack":"_16AherXwrw6jb6oWmd1-rD","column":"_2aPTYjcH9yg9cuQHCKHUlW","alignToStart":"_1XzuCosdZoSQi5e6vh6nyK","alignToEnd":"_3SWUIEMqIANc2ozMtPn-hm"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/components/containers/Stack.css
// module id = 206
// module chunks = 0